module.exports = function () {
    $(document).ready(function () {

        var helper = require('../../helper');
        var ToastrController = new (require('../../services/ToastrController'));

        var clientId = $('.js-property-field-typeahead').data('client');

        /*********************
         * TYPEAHEAD SECTION *
         *********************/
        /** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/properties/client/"+clientId+"/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                        name: object.name,
                        property_id: object.property_id
                    };
                });
            }
        });

        /** Run TypeAhead */
        $('.typeahead').typeahead(null, {
            minLength: 1,
            display: 'name',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'name',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find properties', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + ' (' + data.property_id + ')' + '</strong></p>';
                }
            },
            source: engine
        });


        /*************************************
         * TYPEAHEAD SELECTED PROPERTY EVENT *
         *************************************/

        $('.js-property-field-typeahead').bind('typeahead:select', function (ev, suggestions) {

            var $this = $(this),
                blockId = $this.data('block'),
                propertyId = suggestions.id

            $.ajax({
                    type: 'GET',
                    url: helper.getOrigin() + "/api/blocks/"+blockId+"/property/"+propertyId+"/add"
            }).done(function(data) {

                if(data.type == 'success'){
                    ToastrController.showSuccess(data.message);
                    location.reload();
                } else if(data.type == 'error'){
                    ToastrController.showDanger(data.message);
                } else{
                    ToastrController.showDanger('Something went really wrong!');
                }
            });

        });

    });
}();
